import { Button } from 'antd';
import { ExpandOutlined, CompressOutlined } from '@ant-design/icons';
import { useRef } from 'react';
import styles from './Fullscreenable.module.scss';
const Fullscreenable = ({
  children
}) => {
  const ref = useRef();
  return <div ref={ref} className={styles.fullscreenable} data-sentry-component="Fullscreenable" data-sentry-source-file="Fullscreenable.jsx">
		{children}
		{document.fullscreenEnabled && <>
					<button className={styles.enable} onClick={() => ref.current?.requestFullscreen()}><ExpandOutlined /></button>
					<button className={styles.disable} onClick={() => document.fullscreenElement && document.exitFullscreen()}><CompressOutlined /></button>
				</>}
		</div>;
};
export default Fullscreenable;